// extracted by mini-css-extract-plugin
module.exports = {"layout":"Home_layout__Pw6fU","home-container__title":"Home_home-container__title__3Z6iV","loading":"Home_loading__3mCjE"};